import type {
  ValidationFunctionForArrays,
  ValidationFunctionResult,
  ValidationRule,
} from './types';

const createResultObject = <T, Params>(
  result: ValidationFunctionResult<T, Params>,
) => {
  if (typeof result === 'boolean') {
    return { isValid: result };
  } else {
    return result;
  }
};

export const getIsValid = <T, Params>(
  result: ValidationFunctionResult<T, Params>,
) => {
  if (typeof result === 'object') {
    return result.isValid;
  } else {
    return result;
  }
};

export function forArray<T, MessageParams, FnParams>(
  rule: ValidationRule<T, MessageParams, FnParams>,
): ValidationRule<(T | null | undefined)[], MessageParams, FnParams> {
  const fn = rule.fn;

  const newFn: ValidationFunctionForArrays<
    (T | null | undefined)[],
    FnParams
  > = (values) => {
    const results: { isValid: boolean; params?: FnParams }[] = [];
    let isValid = true;
    for (const value of values ?? []) {
      const result = fn(value);
      results.push(createResultObject<T, FnParams>(result));
      const isValueValid = getIsValid<T, FnParams>(result);
      if (!isValueValid) {
        isValid = false;
      }
    }
    return { isValid, results };
  };
  return { ...rule, fn: newFn };
}
